/* eslint-disable no-unused-vars, max-classes-per-file */

class Validation {
  constructor(pipeline, formControl) {
    this.pipeline = pipeline;
    this.formControl = formControl;
  }

  addErrorHighlight(target) {
    const targetControl = this ? this.formControl : target;

    if (!(targetControl instanceof Element)) return;

    targetControl.classList.add('error');
  }

  removeErrorHighlight(target) {
    const targetControl = this ? this.formControl : target;

    if (targetControl instanceof Element) {
      targetControl.classList.remove('error');
      targetControl.style = '';
    }
  }

  addError(target, message, isExist = false) {
    const targetControl = this ? this.formControl : target;

    if (!(targetControl instanceof Element) || !message) return;

    const errorField = target.closest('form').querySelector(
      `[data-error-for='${target.id}']`,
    );

    if (errorField) {
      errorField.innerText = message;
      errorField.style.display = 'block';
    } else {
      const newErrorField = document.createElement('P');

      newErrorField.classList.add('error-msg');
      newErrorField.style.display = 'block';
      newErrorField.dataset.errorFor = target.id;
      newErrorField.innerText = message;
      newErrorField.setAttribute('role', 'alert');
      target.insertAdjacentElement('afterend', newErrorField);
    }

    if (isExist) {
      target.closest('.registration__email').querySelector('ul').style.display = 'none';

      if (target.type === 'email' && target.closest('.registration__email')?.querySelector('ul')) {
        target.closest('.registration__email').querySelector('ul').style.display = 'flex';
      }
    }
  }

  removeError(target) {
    const targetControl = this ? this.formControl : target;

    const errorField = target.closest('form').querySelector(
      `[data-error-for='${target.id}']`,
    );

    if (errorField) {
      errorField.innerText = '';
      errorField.style.display = 'none';
      // targetControl.style.border = '2px solid';
    }

    if (target.type === 'email' && target.closest('.registration__email')) {
      target.closest('.registration__email').querySelector('ul').style.display = 'none';
    }
  }

  validate(event) {

    const { value, type } = event.target;
    const inputWrapper = `${event.target.name}`;

    const enrollmentForm = document.querySelector('#signup-form');
    const sendToDatalayer = enrollmentForm?.getAttribute('data-send-datalayer');
    const formType = enrollmentForm?.getAttribute('data-form-type');


    if(!inputWrapper.includes('password')) document.querySelector(`[name="${event.target.name}"]`)?.setAttribute('value', value);
    const {
      pipeline,
      addErrorHighlight,
      removeErrorHighlight,
      addError,
      removeError,
    } = this.self;
    const { pass, error } = pipeline(value);

    if (!pass) {
      addErrorHighlight(event.target);
      addError(event.target, error);

      if (event.target.value !='' && sendToDatalayer && event.target.getAttribute('data-error') != '1') {
        event.target.setAttribute('data-error', '1');

        window.dataLayer.push({
          "event": "user_registration_failure",
          "form_name": event.target.closest('form').name,
          "form_field": event.target.name,
          "form_step": event.target.getAttribute('data-step'),
          "form_error": error,
          "Page URL": window.location.href.split("?")[0]
        });
      }

      if (event.target.name === 'phoneNumber') {
        const smsOptin = document.querySelector('[name="field_enroll_sms_optin"]');
        const editProfile = document.querySelector('.edit-form');

        if ((event.target.value.length === 0 && !editProfile && !smsOptin?.checked) || (smsOptin.value === '' && event.target.value.length === 0)) {
          removeErrorHighlight(event.target);
          removeError(event.target);
        }
      }
    } else {
      let datalayerSuccess = event.target.getAttribute('data-success');
      if (event.target.value !='' && sendToDatalayer && datalayerSuccess =='') {
        
        //add datalayer to capture step-wise completion
        if (event.target.name == 'email') {
          let firstNameInput;
          let lastNameInput;
          if (formType != 'short-form') {
            firstNameInput = document.querySelector('[name="firstname"]');
            lastNameInput = document.querySelector('[name="lastname"]');
          } else {
            firstNameInput = document.querySelector('[name="firstName"]');
            lastNameInput = document.querySelector('[name="lastName"]');
          }

          if (firstNameInput.getAttribute('data-success')=='1' && lastNameInput.getAttribute('data-success')=='1' && event.target.getAttribute('data-success') != '1' ) {
            window.dataLayer.push({
              "event": "user_registration_form_step",
              "form_name": enrollmentForm?.name,
              "form_step": event.target.getAttribute('data-step'),
              "Page URL": window.location.href.split("?")[0]
            })
          }

          event.target.setAttribute('data-success', '1');

          window.dataLayer.push({
            "event": "user_registration_form",
            "form_name": enrollmentForm?.name,
            "form_step": event.target.getAttribute('data-step'),
            "form_field": event.target.name,
            "Page URL": window.location.href.split("?")[0]
          });

        } else if (event.target.name == 'dob') {

          if(formType != 'short-form') {
   
            const passwordInput = document?.querySelector('[name="password"]');

            if (passwordInput && passwordInput.getAttribute('data-success')=='1' || event.target.value !='' && event.target.getAttribute('data-success') != '1' ) {
              window.dataLayer.push({
                "event": "user_registration_form_step",
                "form_name": enrollmentForm?.name,
                "form_step": event.target.getAttribute('data-step'),
                "Page URL": window.location.href.split("?")[0]
              })
            }
            event.target.setAttribute('data-success', '1');
            window.dataLayer.push({
              "event": "user_registration_form",
              "form_name": enrollmentForm?.name,
              "form_step": event.target.getAttribute('data-step'),
              "form_field": event.target.name,
              "Page URL": window.location.href.split("?")[0]
            });
          }

        } else if (event.target.name == 'zipCode2') {
          const cityInput = document.querySelector('[name="city"]');
          const provinceInput = document.querySelector('[name="AddressProvinceNew"]');
          const zipOneInput = document.querySelector('[name="zipCode1"]');
          const zipTwoInput = document.querySelector('[name="zipCode2"]');
        
          if (cityInput.value !='' && provinceInput.value !='' && zipOneInput.value !='' && zipTwoInput.value !='' && event.target.getAttribute('data-success') != '1') {
            window.dataLayer.push({
              "event": "user_registration_form_step",
              "form_name": getClosestFormName(cityInput),
              "form_step": event.target.getAttribute('data-step'),
              "Page URL": window.location.href
            });

            event.target.setAttribute('data-success', '1');
            window.dataLayer.push({
              "event": "user_registration_form",
              "form_name": enrollmentForm?.name,
              "form_step": event.target.getAttribute('data-step'),
              "form_field": event.target.name,
              "Page URL": window.location.href
            });
          }
        } else {
          event.target.setAttribute('data-success', '1');
          window.dataLayer.push({
            "event": "user_registration_form",
            "form_name": enrollmentForm?.name,
            "form_step": event.target.getAttribute('data-step'),
            "form_field": event.target.name,
            "Page URL": window.location.href
          });
        }
      }
       
      removeErrorHighlight(event.target);
      removeError(event.target);

      if (event.target.classList.contains('no-validation') && type === 'email') {
        return;
      }

      const isCustomer = document.querySelector('[name="customer"]')?.value;
      if (headerData('dep-mode') === '1') {

        const depErrorWrapper = document.querySelector('.under-maintenance');
        const depError = depErrorWrapper?.querySelector('.error-msg');
        if (!depError) depErrorWrapper.insertAdjacentHTML('afterbegin', I18n['dep.maintainance_mode.error_msg_html']);
        depErrorWrapper.scrollIntoView({behavior: 'smooth', block: 'end'});

      } else {
        
        if (isCustomer !== 'true' && document.querySelector('.registration-form') && type === 'email') {
          const email = event.target.value;
          const requestBody = {
            data: _hashed_password(JSON.stringify({ userid: email })),
            source: 'WEB',
          };

          const url = `${ThemeSettings.sourceApi}enfa-cdp-api/v1/enfa-user-app/shop-token`;
          const myHeaders = new Headers();
          myHeaders.append('Content-Type', 'application/json');
          const authData = {};
          authData.data = `${ThemeSettings.token}`;

          const accessToken = getCookie('_uat');
          if (accessToken) {
            myHeaders.append('Authorization', `Bearer ${accessToken}`);
            fetch(`${ThemeSettings.sourceApi}enfa-cdp-api/v1/enfa-user-app/uservalidate`, {
              method: 'POST',
              body: JSON.stringify(requestBody),
              headers: myHeaders,
            }).then((result) => result.json()).then((responseData) => {
              if (responseData.status_code === 400) {
                addErrorHighlight(event.target);
                addError(event.target, responseData.message, true);
                
                //send form failure info to datalayer
                if (event.target.value !='' && sendToDatalayer && event.target.getAttribute('data-error') != '1') {
                  event.target.setAttribute('data-error', '1');

                  window.dataLayer.push({
                    "event": "user_registration_failure",
                    "form_name": event.target.closest('form').name,
                    "form_field": event.target.name,
                    "form_step": event.target.getAttribute('data-step'),
                    "form_error": responseData.message,
                    "Page URL": window.location.href.split("?")[0]
                  });
                }
              }
            });
          } else {
            fetch(url, {
              method: 'POST',
              body: JSON.stringify(authData),
              headers: myHeaders,
            }).then((result) => result.json())
              .then((response) => {
                setCookie('_uat', response.access_token, 10);
                myHeaders.append('Authorization', `Bearer ${response.access_token}`);
    
                fetch(`${ThemeSettings.sourceApi}enfa-cdp-api/v1/enfa-user-app/uservalidate`, {
                  method: 'POST',
                  body: JSON.stringify(requestBody),
                  headers: myHeaders,
                }).then((result) => result.json()).then((responseData) => {
                  if (responseData.status_code === 400) {
                    addErrorHighlight(event.target);
                    addError(event.target, responseData.message, true);
                    //send form failure info to datalayer
                    if (event.target.value !='' && sendToDatalayer && event.target.getAttribute('data-error') != '1') {
                      event.target.setAttribute('data-error', '1');

                      window.dataLayer.push({
                        "event": "user_registration_failure",
                        "form_name": event.target.closest('form').name,
                        "form_field": event.target.name,
                        "form_step": event.target.getAttribute('data-step'),
                        "form_error": responseData.message,
                        "Page URL": window.location.href.split("?")[0]
                      });
                    }
                   
                  }
                });
              });
          }
        }
      }
    }
  }

  forceValidation(removeErrors = true) {
    const { value } = this.formControl;
    const { pass, error } = this.pipeline(value);

    if (!pass) {
      this.addErrorHighlight(this.formControl);
      this.addError(this.formControl, error);

      if (this.formControl.name === 'phoneNumber') {
        const qeepseekOptin = document.querySelector('[name="field_enroll_qeepsake_optin"]');
        const smsOptin = document.querySelector('[name="field_enroll_sms_optin"]');
        const editProfile = document.querySelector('.edit-form');

        if ((this.formControl.value.length === 0 && !editProfile && !smsOptin?.checked) || (smsOptin.value === '' && this.formControl.value.length === 0)) {
          this.removeErrorHighlight(this.formControl);
          this.removeError(this.formControl);

          return true;
        }
      }
    }

    return pass;
  }

  attachEvents() {
    this.formControl.addEventListener(
      'blur',
      { handleEvent: this.validate, self: this },
      false,
    );
    // this.formControl.addEventListener(
    //   'blur',
    //   { handleEvent: this.validate, self: this },
    //   false,
    // );
  }

  detachEvents() {
    this.formControl.removeEventListener(
      'blur',
      { handleEvent: this.validate, self: this },
      false,
    );
    // this.formControl.removeEventListener(
    //   'blur',
    //   { handleEvent: this.validate, self: this },
    //   false,
    // );
  }

  init() {
    this.attachEvents();
  }

  clean() {
    this.removeErrorHighlight(this.formControl);
    this.removeError(this.formControl);
    this.detachEvents();
  }
}

class ValidationGroup {
  constructor(group) {
    this.group = group;
  }

  init() {
    if (this.group.length === 0) {
      throw new Error('Validation group cannot be empty!');
    }

    this.group.forEach((validation) => {
      validation.init();
    });
  }

  valid() {
    const isInvalid = this.group.some(
      (validation) => validation.forceValidation() === false,
    );

    return !isInvalid;
  }

  validate() {
    this.group.forEach((validation) => {
      validation.forceValidation();
    });
  }

  clean() {
    this.group.forEach((validation) => {
      validation.clean();
    });
  }
}
